import { DashboardLayoutBackButton } from "./components/DashboardLayoutBackButton"
import { DashboardLayoutCard } from "./components/DashboardLayoutCard"
import { DashboardLayoutHeader } from "./components/DashboardLayoutHeader"
import { DashboardLayoutHomePageHeader } from "./components/DashboardLayoutHomePageHeader"
import { DashboardLayoutMain } from "./components/DashboardLayoutMain"
import { DashboardLayoutNested } from "./components/DashboardLayoutNested"
import { DashboardLayoutRoot } from "./components/DashboardLayoutRoot"
import { DashboardLayoutSection } from "./components/DashboardLayoutSection"
import { DashboardLayoutSelectArea } from "./components/DashboardLayoutSelectArea"
import { DashboardLayoutTitle } from "./components/DashboardLayoutTitle"

export { type Breadcrumb } from "./types/Breadcrumb"

export const DashboardLayout = {
    BackButton: DashboardLayoutBackButton,
    Card: DashboardLayoutCard,
    Header: DashboardLayoutHeader,
    HomePageHeader: DashboardLayoutHomePageHeader,
    Main: DashboardLayoutMain,
    Nested: DashboardLayoutNested,
    Root: DashboardLayoutRoot,
    Section: DashboardLayoutSection,
    SelectArea: DashboardLayoutSelectArea,
    Title: DashboardLayoutTitle,
}
